import { Appearance } from '@stripe/stripe-js'

export const defaultAppearance: Appearance = {
  theme: 'stripe',
  variables: {
    colorPrimary: '#ceced0',
    colorBackground: '#ffffff',
    colorText: '#30313d',
    fontFamily: `system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto`,
    spacingUnit: 'var(--global-space)',
  },
  rules: {
    '.Input': {
      boxShadow: 'none',
    },
    '.Input:focus': {
      boxShadow: 'none',
    },
  },
}
